module.exports = __webpack_public_path__ + "img/invite-user-green.0a03325e.svg";